import { executeMutation } from '@lyearn-team/content-processing-library';
import { showSnackbar } from '@lyearn-team/frontend-components/dist/showSnackbar/showSnackbar';

const executeMutationWrapper = (
  command,
  user,
  content,
  allParentContents,
  childContents,
  states,
  enrolments,
  stateInteractions
) => {
  try {
    return executeMutation(
      command,
      user,
      content,
      allParentContents,
      childContents,
      states,
      enrolments,
      stateInteractions
    );
  } catch (error) {
    console.error('error in Execute mutation - wrapper:', error);

    console.error('error in mutationSync', error, error.stack);

    window.analytics &&
      window.analytics.track('ERROR_IN_MUTATION_SYNC', {
        url: window.location.href,
        cookie: document.cookie
      });
    window.bugsnagClient && window.bugsnagClient.notify(error);

    showSnackbar({
      label: 'Error in saving your progress, please refresh and try again, or contact support.',
      duration: 10,
      buttons: [{ onClick: () => window.location.reload(true), label: 'Reload' }],
      status: 'error'
    });
    return {
      error
    };
  }
};

export default executeMutationWrapper;
